import React from 'react';
import { Tooltip } from '~/components/ui/Tooltip';
import type { UserProfileProps } from '~/lib/types/netlify';

export const UserProfile = ({ user, onDisconnect }: UserProfileProps) => {
  return (
    <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10">
      <div className="flex items-center gap-3">
        {user.avatar && (
          <img src={user.avatar} alt={user.name || 'User'} className="w-8 h-8 rounded-full border border-white/10" />
        )}
        <div className="flex-1 min-w-0">
          {user.name && <p className="text-sm text-white font-medium leading-snug m-0">{user.name}</p>}
          {user.email && <p className="text-xs text-[#e7e7e7]/70 leading-snug m-0">{user.email}</p>}
        </div>
      </div>
      <Tooltip content="Disconnect">
        <button
          onClick={onDisconnect}
          className="p-2 text-[#e7e7e7]/70 hover:text-white bg-white/5 
            hover:bg-white/10 rounded-md transition-colors"
        >
          <div className="i-ph:sign-out w-4 h-4" />
        </button>
      </Tooltip>
    </div>
  );
};
